import apiClient from '../client';
import type { OperationTask, PaginatedResponse } from '../../types';

interface PageParams {
  page?: number;
  size?: number;
  projectId?: string;
  farmOperationId?: string;
  search?: string;
  status?: string;
  assigneeType?: string;
}

const operationTaskService = {
  getAll: async (params: PageParams = {}) => {
    const { page = 0, size = 10, projectId, farmOperationId, search, status, assigneeType } = params;
    const qs = new URLSearchParams({ page: page.toString(), size: size.toString() });
    if (projectId) qs.set('projectId', projectId);
    if (farmOperationId) qs.set('farmOperationId', farmOperationId);
    if (search) qs.set('search', search);
    if (status) qs.set('status', status);
    if (assigneeType) qs.set('assigneeType', assigneeType);
    const res = await apiClient.get<PaginatedResponse<OperationTask>>(`/operation-tasks?${qs}`);
    return res.data;
  },

  getByOperation: async (farmOperationId: string) => {
    const res = await apiClient.get<OperationTask[]>(`/operation-tasks/operation/${farmOperationId}`);
    return res.data;
  },

  getById: async (id: string) => {
    const res = await apiClient.get<OperationTask>(`/operation-tasks/${id}`);
    return res.data;
  },
};

export default operationTaskService;
